import React, { useEffect, useContext, useState } from 'react';
import Icon_Close from '../../../Assets/Icons/Icon_Close.png';
import Icon_Map from '../../../Assets/Icons/Icon_Color_ChangeLocation.png';
import { Context_UI } from '../../../Contexts/Context_UI';
import { useScheduleManagement } from '../../../Contexts/Context_ScheduleManagement';
import { useMapRenderer } from '../../../Contexts/Context_MapRenderer';
import UI_Card from '../../ERUMAUI/UI_Card';
import UI_ChipGroup from '../../ERUMAUI/UI_ChipGroup';
import { useAccounts } from '../../../Contexts/Context_Accounts';
import UI_Dropdown from '../../ERUMAUI/UI_Dropdown';
import { useTemplating } from '../../../Contexts/Context_Templating';
import { useStatus } from '../../../Contexts/Context_Status_Global';
import UI_Divider from '../../ERUMAUI/UI_Divider';
import UI_Form from '../../ERUMAUI/UI_Form';
import UI_Input_Text from '../../ERUMAUI/UI_Input_Text';
import UI_Icon from '../../ERUMAUI/UI_Icons';
import UI_Button from '../../ERUMAUI/UI_Button';
import UI_UpdatingStatus from '../../ERUMAUI/UI_UpdatingStatus';
import Controls_Map_Selector from '../../InteractiveMap/Controls_Map_Selector';

export default function Subwindow_Modal_Schedule_Reschedule({ id, zIndex, isActive }) {
    const UI = useContext(Context_UI);
    const { Schedule_Information, Schedule_Information_Set, Time_Range_Parse, Schedule_Action_Mode, Status_Parse, Time_Parse, Conflicts, Conflict_Check, Conflict_Recommendation } = useScheduleManagement();
    const { Room_Get_Address, Map_Composition, Get_Parent_Index } = useMapRenderer();
    const { Account_Fetch_ByID_Basic } = useAccounts();
    const [Account, Account_Set] = useState({ Name: "", Email: "" });
    const { Template_List } = useTemplating();
    const { Confirmer_Respond } = useStatus();
    const Close = (Type) => {
        setTimeout(function () {
            UI.Subwindows_Close(id);
        }, 500);
    }

    const [Schedule_Information_Old, Schedule_Information_Old_Set] = useState(Schedule_Information);
    const [Schedule_Information_Loaded, Schedule_Information_Loaded_Set] = useState(false);

    useEffect(() => {
        if (Schedule_Information_Loaded == false) {
            Schedule_Information_Old_Set(Schedule_Information);
            Schedule_Information_Loaded_Set(true);
        }

    }, []);


    useEffect(() => {
        Fetch(Schedule_Information.Requester.RequesterID)
    }, [Schedule_Information]);

    useEffect(() => {
        document.getElementById("Reschedule_Reason").querySelector(".Dropdown_Button").click();
        // console.log(Format_Time(Schedule_Information.Time.Start, "time"));
    }, []);

    const Fetch = async (ID) => {
        const Data = await Account_Fetch_ByID_Basic(ID);
        Account_Set(Data);
    }

    const Confirm = async () => {
        const Cleared = await UI.Input_Evaluate([{
            ID: "Reschedule_Reason",
            Type: "Dropdown",
            AC: "No relocation reason specified",
            Prompt: "Specifying a reason is required."
        }])
        if (Cleared) {
            // console.log(Cleared);
            Confirmer_Respond(true, {
                Reason: document.getElementById("Reschedule_Reason").querySelector(".Dropdown_Button").querySelector(".Dropdown_Button_Text").innerText,
                RoomID: UpdatedLocation.RoomID
            }, true, "Window_ScheduleManagement_Schedule_Relocate");
        }

        // UI.Subwindows_Close('Window_MapEditor_RippleDelete');
    }

    const [UpdatedLocation, setUpdatedLocation] = useState({
        Start: new Date(),
        End: new Date(),
        Date: new Date(),
        RoomID: ""
    });

    const Cancel = () => {
        Confirmer_Respond(false, {}, true, "Window_ScheduleManagement_Schedule_Relocate");
    }



    const Suggestion_Accept = (Data, Type) => {
        if (Type === "Room") {
            setUpdatedLocation(prev => ({
                ...prev,
                RoomID: Data._id
            }));
        }
    }

    const [Working_Buildings, Working_Buildings_Set] = useState([]);
    const [Working_Floors, Working_Floors_Set] = useState([]);
    const [Working_Rooms, Working_Rooms_Set] = useState([]);
    const [SelectedLabels, SelectedLabels_Set] = useState({
        building: null,
        floor: null,
        room: null,
    });

    useEffect(() => {
        const Handle = ({ List_ID, Value, Value_Index }) => {
            switch (List_ID) {
                case "Schedule_Building": {
                    const b = Map_Composition[Value_Index];
                    if (!b) return;
                    // cascade arrays
                    Working_Floors_Set(b.Floors || []);
                    Working_Rooms_Set([]);
                    // update labels
                    SelectedLabels_Set({ building: b.Name, floor: null, room: null });
                    // clear room selection in reservation
                    setUpdatedLocation(prev => ({ ...prev, RoomID: "" }));
                    break;
                }
                case "Schedule_Floor": {
                    const f = Working_Floors[Value_Index];
                    if (!f) return;
                    Working_Rooms_Set(f.Rooms || []);
                    SelectedLabels_Set(prev => ({ ...prev, floor: f.Name, room: null }));
                    setUpdatedLocation(prev => ({ ...prev, RoomID: "" }));
                    break;
                }
                case "Schedule_Room": {
                    const r = Working_Rooms[Value_Index];
                    if (!r) return;
                    SelectedLabels_Set(prev => ({ ...prev, room: r.Name }));
                    setUpdatedLocation(prev => ({ ...prev, RoomID: r._id }));
                    // optional: mirror on the map
                    // Room_Highlight(r._id, 1.6, 400, "Directory");
                    break;
                }
                default:
                    break;
            }
        };

        UI.on("Dropdown_Value_Submitted", Handle);
        return () => UI.off("Dropdown_Value_Submitted", Handle);
    }, [UI, Map_Composition, Working_Floors, Working_Rooms, setUpdatedLocation, UpdatedLocation]);

    useEffect(() => {
        const Structure = Get_Parent_Index(UpdatedLocation.RoomID);
        if (!Structure) return;

        SelectedLabels_Set(prev => ({
            ...prev,
            building: Map_Composition[Structure.Index_Building].Name,
            floor: Map_Composition[Structure.Index_Building]?.Floors[Structure.Index_Floor].Name || null,
            room: Map_Composition[Structure.Index_Building].Floors[Structure.Index_Floor].Rooms[Structure.Index_Room].Name
        }));

        Working_Floors_Set(Map_Composition[Structure.Index_Building]?.Floors);
        Working_Rooms_Set(Map_Composition[Structure.Index_Building]?.Floors[Structure.Index_Floor].Rooms);
    }, [UpdatedLocation.RoomID, Map_Composition]);

    

    useEffect(() => {
        if (Schedule_Information?.Time) {
            setUpdatedLocation({
                Start: Schedule_Information.Time.Start,
                End: Schedule_Information.Time.End,
                Date: Schedule_Information.Time.Start,
                RoomID: Schedule_Information.RoomID
            });
        }
    }, [Schedule_Information]);

    useEffect(() => {
        if (UpdatedLocation && Schedule_Information) {
            Conflict_Check("Temporary", {
                RoomID: UpdatedLocation.RoomID,
                Time: {
                    Start: UpdatedLocation.Start,
                    End: UpdatedLocation.End
                },
                ScheduleID: Schedule_Information._id
            });
        }
    }, [UpdatedLocation, Schedule_Information]);

    const Handle_Map = async () => {
        UI.Subwindows_Open("Window_Map_ChooseRoom");
        // const { Response, Data } = await Confirmer_Confirm('Window_Map_ChooseRoom');
        // if (Response === "Confirmed") {
        //     console.log(Data.RoomID);
        // }
    }

    const Handle_Room_Select = (RoomID) => {
        setUpdatedLocation(Prev => ({
            ...Prev,
            RoomID: RoomID
        }));
    }



    return (
        <ui-subwindow Type='Subwindow' id={id} State='Active' Visibility='Open' {...(!isActive ? { inert: "" } : {})} style={{ height: "calc(100% - 20px)" }}>
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>

                </h2>
                <button className='Subwindow_TitleBar_Control' onClick={Cancel}             >
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content>
                <div style={{ display: "grid", gridTemplateColumns: "auto 1fr", gap: "10px", alignItems: "center" }}>
                    <div className='Subwindow_Content_Icon'>
                        <img src={Icon_Map} className='Subwindow_Content_Icon_Image' draggable={false} loading='lazy' />
                    </div>
                    <div>
                        <h2 className='Subwindow_TitleBar_Title' style={{ textAlign: "left", marginBottom: "10px" }}>
                            Relocate this activity
                        </h2>

                        <p className='General_Paragraph' style={{ textAlign: "left", marginBottom: "10px" }}>
                            Please specify a new location for this request. You cannot relocate this activity if it conflicts with other activities.
                        </p>
                    </div>
                </div>
                <div className='General_Split' Split="3">
                    <div>
                        <UI_Card Type="Panel_Info" Text="Name" Figure={Schedule_Information.Name} />
                        <UI_Card Type="Panel_Info" Text="Requested time" Figure={Time_Range_Parse(Schedule_Information.Time.Start, Schedule_Information.Time.End)} />
                        <UI_Card Type="Panel_Info" Text="Requested location" Figure={Room_Get_Address(Schedule_Information.RoomID)} />
                        <UI_Card Type="Panel_Info" Text="Type of activity" Figure={Schedule_Information.Activity.Type} />
                        <UI_Card Type="Panel_Info" Text="Requestant's name" Figure={Account.Name} />
                        <UI_Card Type="Panel_Info" Text="Requestant's email" Figure={Account.Email} />
                        <UI_Card Type="Panel_Info" Text="Number of attendees" Figure={Schedule_Information.Activity.Attendees.Names.length} />
                        <div className='AM_Details_Data' id={id}>
                            <p className='General_Paragraph'>
                                Reservation status
                            </p>
                            <UI_ChipGroup Items={Status_Parse(Schedule_Information)} />
                        </div>
                    </div>
                    <div>
                        <UI_Divider Text="Original location" />
                        <UI_Form Composition="ByTwo">
                            <label className='Input_Label'>
                                Building:
                            </label>
                            <label className='Input_Label'>
                                <b>{Room_Get_Address(Schedule_Information.RoomID, "Building")}</b>
                            </label>
                            <label className='Input_Label'>
                                Floor:
                            </label>
                            <label className='Input_Label'>
                                <b>{Room_Get_Address(Schedule_Information.RoomID, "Floor")}</b>
                            </label>
                            <label className='Input_Label'>
                                Room:
                            </label>
                            <label className='Input_Label'>
                                <b>{Room_Get_Address(Schedule_Information.RoomID, "Room")}</b>
                            </label>
                        </UI_Form>
                        <UI_Divider Text="Updated location" />
                        <Controls_Map_Selector
                            NoTime={true}
                            Room_Selectable={true}
                            Room_Show={true}
                            Form={true}
                            Labels={true}
                            onRoomSelect={(Room) => Handle_Room_Select(Room)}
                        />
                        {/* <UI_Divider/>
                        <UI_Button
                            Fill={true}
                            Icon_Position="Left"
                            Icon={<UI_Icon Name="Map" />}
                            Text="Choose from the interactive map"
                            OnClick={Handle_Map}
                        /> */}
                        <UI_Form Composition="ByTwo">
                            
                            {/* <UI_Dropdown
                                id="Schedule_Building"
                                Label_Text="Building:"
                                InitialTitle="Building"
                                Items={Map_Composition}
                                Item_Key="Name"
                                Selected={SelectedLabels.building}
                                Fill
                            />
                            <UI_Dropdown
                                id="Schedule_Floor"
                                Label_Text="Floor:"
                                InitialTitle="Floor"
                                Items={Working_Floors}
                                Item_Key="Name"
                                Selected={SelectedLabels.floor}
                                Fill
                            />
                            <UI_Dropdown
                                id="Schedule_Room"
                                Label_Text="Room:"
                                InitialTitle="Room"
                                Items={Working_Rooms}
                                Item_Key="Name"
                                Selected={SelectedLabels.room}
                                Fill />
                            <span></span>
                            <UI_Button
                                Icon={<UI_Icon Name="Map" />}
                                Icon_Position="Left"
                                Text="Choose from the interactive map"
                                OnClick={() => UI.Subwindows_Open("Window_ScheduleManagement_Map")} /> */}

                        </UI_Form>
                        <div className='AM_Details_Data' id={id}>
                            <p className='General_Paragraph'>
                                Pick a relocation reason
                            </p>
                            <UI_Dropdown id="Reschedule_Reason" Items={Template_List.Reason.Request_Relocated} InitialTitle="No relocation reason specified" />
                        </div>
                    </div>
                    <div>
                        <UI_Divider Text="Conflicting schedules" />
                        <UI_UpdatingStatus
                            State={Conflicts.Hard.length + Conflicts.Soft.length > 0 ? "Bad" : "Good"}
                            Good={{
                                Type: "Default",
                                Icon: "Default",
                                Title: "No schedule conflicts",
                                Text: "No schedule conflict detected. You can continue with your reservation."
                            }}
                            Bad={{
                                Type: "Custom",
                                Content: <div className='General_List'>
                                    {Conflicts.Hard.map((Item) => (
                                        <UI_Card
                                            Type="Schedule_List"
                                            Figure={
                                                {
                                                    Title: Item.Name,
                                                    Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                    Chip: Status_Parse(Item)
                                                }
                                            }
                                        />
                                    ))}
                                    {Conflicts.Soft.map((Item) => (
                                        <UI_Card
                                            Type="Schedule_List"
                                            Figure={
                                                {
                                                    Title: Item.Name,
                                                    Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                    Chip: Status_Parse(Item)
                                                }
                                            }
                                        />
                                    ))}
                                </div>
                            }}
                        />
                        <UI_Divider Text="Location suggestions" />
                        <UI_UpdatingStatus
                            State={Conflicts.Hard.length + Conflicts.Soft.length > 0 ? "Bad" : "Good"}
                            Good={{
                                Type: "Default",
                                Icon: "Default",
                                Title: "No schedule conflicts",
                                Text: "No schedule conflict detected. You can continue with your reservation."
                            }}
                            Bad={{
                                Type: "Custom",
                                Content: <>
                                    {/* <p className='General_Paragraph' style={{ marginBottom: "20px" }}>
                                        Click a suggestion below to apply it to your reservation
                                    </p> */}
                                    <div className='General_List'>
                                        {Conflict_Recommendation?.Room?.map((Item) => (
                                            <UI_Card
                                                Type="Schedule_List"
                                                Figure={
                                                    {
                                                        Title: Item.Name,
                                                        Main: "",
                                                        Chip: []
                                                    }
                                                }
                                                // onClick={() => Suggestion_Accept(Item, "Room")}
                                            />
                                        ))}
                                    </div>
                                </>
                            }}
                        />
                    </div>

                </div>



            </ui-subwindow-content>
            <ui-subwindow-controls>
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Cancel}>
                    Cancel
                </button>
                {Conflicts.Hard.length > 0 ?
                    <button className='General_Button Subwindow_Control' Type='Secondary'>
                        Resolve conflict to continue
                    </button>
                    :
                    <button className='General_Button Subwindow_Control' Type='Secondary' State="Neutral" onClick={Confirm}>
                        Relocate
                    </button>
                }

            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
